import React, { useEffect, useState } from "react";
import { CustomInput } from "../../../components/main_comps/custom_input/CustomInput";
import RowButton from "../../../components/ui_comps/RowButton";
import CustomSelect from "../../../components/main_comps/custom_select";
import { Upwardarrow } from "../../../../utility/constants/assetsManager";
import CustomUploadField2 from "../../../components/ui_comps/CustomUploadField2";
import { formDataPush } from "../clients/client_onboard/ResellerDetails";
import secureStorage from "../../../../services/secureStorage";
import {
  SS_AUTH_TOKEN,
  SS_USER_HASH_ID,
} from "../../../../utility/constants/secureStorageManager";
import { API_ENDPOINT } from "../../../../data/network/services/ApiEndpoint";
import { STATUS_CODE_200 } from "../../../../utility/constants/valueConstants";
import { useSnackbar } from "notistack";

function AddPrefundModal({ onSuccess }) {
  const [accountNumber, setAccountNumber] = useState("");
  const [ifscCode, setIfscCode] = useState("");
  const [amount, setAmount] = useState("");
  const [transferMode, setTransferMode] = useState("");
  const [remarks, setRemarks] = useState("");
  const [paymentSlip, setPaymentSlip] = useState("");
  const [utr, setUtr] = useState("");
  const [loading, setLoading] = useState(false);
  const { enqueueSnackbar } = useSnackbar();

  const transferModeOptions = [
    { label: "NEFT", value: "neft" },
    { label: "RTGS", value: "rtgs" },
    { label: "IMPS", value: "imps" },
  ];
  const inputStyle = {
    backgroundColor: "#F3F3F3",
    alignSelf: "center",
    height: 50,
    width: "100%",
    boxShadow: "none",
    outline: "none",
    paddingLeft: 10,
    borderRadius: 5,
    boxSizing: "border-box",
  };
  const containerStyle = {
    height: 50,
    marginBottom: 20,
    width: "100%",
    paddingLeft: 0,
  };

  const textStyle = {
    fontSize: 12,
    color: "#6C6B6B",
    margin: "5px 0px 5px 0px",
  };

  const onClickRequestPrefund = (data) => {
    if (
      !utr ||
      !remarks ||
      !accountNumber ||
      !transferMode.value ||
      !paymentSlip ||
      !amount
    ) {
      enqueueSnackbar("Please fill all the details", { variant: "error" });
      return;
    }
    setLoading(true);
    const clientId = secureStorage.getItem(SS_USER_HASH_ID);

    const formdata = formDataPush({
      beneAccountNo: accountNumber,
      transferType: transferMode.value,
      transferUniqueNo: utr,
      transferAmount: amount,
      remarks: remarks,
      paymentSlip: paymentSlip,
      clientId,
    });
    const token = secureStorage.getItem(SS_AUTH_TOKEN);
    fetch(API_ENDPOINT.core_url + "prefund/request", {
      body: formdata,
      headers: {
        Authorization: "Bearer " + token,
      },
      method: "POST",
    })
      .then((response) => response.json())
      .then((response) => {
        if (response.statusCode === STATUS_CODE_200) {
          enqueueSnackbar(response.message, {
            variant: "success",
          });
          onSuccess();
        } else {
          enqueueSnackbar(response.message, {
            variant: "error",
          });
        }
      })
      .catch((err) => {
        enqueueSnackbar(err.message, {
          variant: "error",
        });
      })
      .finally((res) => {
        setLoading(false);
      });
  };

  return (
    <div
      style={{
        width: "100%",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        height: "100%",
        overflow: "auto",
      }}
    >
      <div>
        <p style={textStyle}>UTR Number</p>

        <CustomInput
          value={utr}
          onChange={(data) => setUtr(data)}
          inputcomponentStyles={{ ...inputStyle }}
          placeholder="Enter the number"
          validator="alphaNum"
          type="input"
          inputStyles={{
            ...containerStyle,
          }}
        />
      </div>
      <div>
        <p style={textStyle}>Account Number</p>
        <CustomInput
          value={accountNumber}
          onChange={(data) => setAccountNumber(data)}
          inputcomponentStyles={{ ...inputStyle }}
          placeholder="Bank account number"
          validator="accountNumber"
          type="input"
          inputStyles={{
            ...containerStyle,
          }}
        />
      </div>
      <div>
        <p style={textStyle}>Amount</p>
        <CustomInput
          value={amount}
          onChange={(data) => setAmount(data)}
          inputcomponentStyles={{ ...inputStyle }}
          placeholder="Enter Amount"
          validator="number"
          type="input"
          inputStyles={{
            ...containerStyle,
          }}
        />
      </div>
      <div style={{}}>
        <p style={textStyle}>Type</p>

        <CustomSelect
          value={transferMode}
          options={transferModeOptions}
          onChange={(data) => {
            setTransferMode(data);
          }}
          placeholder={"Type"}
          style={{
            width: "100%",
            // minWidth: 300,
          }}
        />
      </div>
      <div style={{ marginTop: "20px" }}>
        <p style={textStyle}>Payment Slip</p>
        <CustomUploadField2
          document="Payment Slip"
          customIcon={<Upwardarrow />}
          value={paymentSlip}
          // value={reduxData?.others2 ? reduxData.others2 : ""}
          onChange={(data) => {
            setPaymentSlip(data);
          }}
          onClickRemove={() => {
            setPaymentSlip("");
          }}
          imageTypeArray={["jpg", "png", "jpeg"]}
          filesize={10}
          style={{
            maxWidth: "auto",
            backgroundColor: "rgb(243, 243, 243)",
            width: "100%",
            marginBottom: "20px",
          }}
          accept=".png"
          textStyles={{
            color: "#697D95",
          }}
        />
      </div>

      <div>
        <p style={textStyle}>Remarks</p>
        <CustomInput
          value={remarks}
          onChange={(data) => setRemarks(data)}
          inputcomponentStyles={{ ...inputStyle }}
          placeholder="Description"
          validator=""
          type="input"
          inputStyles={{
            ...containerStyle,
          }}
        />
      </div>

      <RowButton
        loading={loading}
        onClickBack={() => {}}
        onClickNext={() => {
          onClickRequestPrefund();
        }}
      />
    </div>
  );
}

export default AddPrefundModal;
